export class TooManyRequestsError extends Error {
  constructor(message = '429') {
    super(message)
    this.name = 'TooManyRequestsError'
    this.status = 429
    this.report = false
  }
}
